import { type UseMutationOptions, useMutation } from "@tanstack/react-query";
import { useParams } from "react-router";
import { useApi } from "~hooks/apiHooks/useApi";
import type { FixtureResponse } from "~types/fixture.ts";
import type { FixtureUpsert } from "../types";

export const useUpdateFixture = (options: UseMutationOptions<FixtureResponse, unknown, FixtureUpsert> = {}) => {
  const request = useApi();
  const { sport, organizationId, fixtureId } = useParams();

  if (!sport || !organizationId || !fixtureId) {
    console.error({ sport, organizationId, fixtureId });
    throw new Error("Missing required params");
  }
  return useMutation<FixtureResponse, unknown, FixtureUpsert, unknown>({
    mutationFn: (body: FixtureUpsert) =>
      request(
        `${sport}/o/${organizationId}/fixtures/${fixtureId}?include=seasons,entities,persons,venues,seasonStages,seasonPools,seasonSeries,seasonRounds`,
        {
          method: "PUT",
          body,
        },
      ),
    ...options,
  });
};
